import axios from 'axios';
import { ExpositionBatchModel } from '../Models/ExpositionBatchModel';


const getExpositionBatch = (batch: ExpositionBatchModel) => axios.post(`classifications/${batch.classificationsId[0]}/expositions`, batch);
const insertExpositionBatch = (batch: ExpositionBatchModel) => axios.post(`classifications/${batch.classificationsId[0]}/expositions/insert-batch`, batch);
const deleteExpositionBatch = (batch: ExpositionBatchModel) => axios.patch(`classifications/${batch.classificationsId[0]}/expositions/delete-batch`, batch);

export default {
    getExpositionBatch,
    insertExpositionBatch,
    deleteExpositionBatch
};